import { render, staticRenderFns } from "./PdfType2.vue?vue&type=template&id=e61b8308&scoped=true&"
import script from "./PdfType2.vue?vue&type=script&lang=js&"
export * from "./PdfType2.vue?vue&type=script&lang=js&"
import style0 from "../../css/pdf.css?vue&type=style&index=0&id=e61b8308&scoped=true&lang=css&"
import style1 from "./PdfType2.vue?vue&type=style&index=1&id=e61b8308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61b8308",
  null
  
)

export default component.exports